import {
  GuestJourneyChurnCards,
  GuestJourneyStageGrid,
  GuestJourneyMemberTrendsResponse,
  GuestJourneyVioTrend,
} from '../guest-journey-reports.types';
import { buildStageGrid } from './stage-grid.utils';

// Values arrive pre-formatted from the BE; the FE renders them verbatim. The
// churn-threshold explanatory note now rides on the card as a `footnote`.
export const churnCardsFixture: GuestJourneyChurnCards = {
  churnThresholdDays: {
    title: 'Churn Threshold',
    value: '60 days',
    footnote: 'Members are considered churned after this many days.',
  },
  membersWhoOrdered: {
    title: 'Members Who Ordered',
    value: '280,487',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
  churnedMembers: {
    title: 'Churned Members',
    value: '42,073',
    trend: { text: 'Trending Up', direction: 'UP', invertColor: true },
  },
  churnRate: {
    title: 'Churn Rate',
    value: '15.0%',
    trend: { text: 'Trending Up', direction: 'UP', invertColor: true },
  },
  medianDaysFromLastOrder: {
    title: 'Median Days From Last Order',
    value: '92',
    trend: { text: 'Trending Up', direction: 'UP', invertColor: true },
  },
  projectedAnnualRevenue: {
    title: 'Lifetime Revenue',
    value: '$12,034.12',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
};

// BE `GuestJourneyInsightDTO[]` — `GET v2/guest-journey/churn/insights`.
export const churnedVioTrendsFixture: GuestJourneyVioTrend[] = [
  {
    text: 'Value Explorers continue to make up the bulk of churned members, signaling consistent early-stage drop-off.',
    movement: { text: 'Moving Down', direction: 'DOWN_LEFT' },
  },
  {
    text: 'Indulgent Superfans churn remains low, reinforcing the stickiness of high-frequency, high-spend guests.',
    movement: { text: 'Moving Down', direction: 'DOWN_LEFT' },
  },
  {
    text: 'Median days from last order is creeping up across Core Regulars, suggesting longer gaps before reactivation.',
    movement: { text: 'Moving Down', direction: 'DOWN_LEFT' },
  },
];

export const churnedGridFixture: GuestJourneyStageGrid = {
  countGrid: buildStageGrid([
    '287',
    '412',
    '188',
    '5,240',
    '9,120',
    '1,840',
    '14,820',
    '8,960',
    '1,206',
  ]),
  spendGrid: buildStageGrid([
    '$17,909',
    '$25,709',
    '$11,731',
    '$204,098',
    '$355,224',
    '$71,668',
    '$357,162',
    '$215,936',
    '$29,065',
  ]),
  visitsGrid: buildStageGrid([
    '488',
    '1,895',
    '1,730',
    '8,908',
    '41,952',
    '16,928',
    '25,194',
    '41,216',
    '11,095',
  ]),
};

export const churnedMemberTrendsFixture: GuestJourneyMemberTrendsResponse = {
  xlabels: [
    'Day 1',
    'Day 15',
    'Day 30',
    'Day 45',
    'Day 60',
    'Day 75',
    'Day 90',
  ],
  series: [
    {
      label: 'Indulgent Superfan',
      data: [180, 195, 210, 225, 240, 255, 270],
    },
    {
      label: 'Core Regular',
      data: [7800, 8120, 8460, 8810, 9020, 9080, 9120],
    },
    {
      label: 'Value Explorer',
      data: [12100, 12640, 13180, 13720, 14210, 14580, 14820],
    },
  ],
};
